import { client } from '@/services/api/axios.ts';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';

export const useGetPlantQuery = ({ plantId }: { plantId: string | undefined }) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['plants', plantId],
    queryFn: async () => {
      const { data } = await client.get<{ body: TPlant }>(`/plants/${plantId}`);

      return data.body;
    },
    enabled: !!plantId,
    initialData: () => {
      const plantsWithoutOverview = queryClient.getQueryState<TPlant[]>(['plants']);
      const plantsWithOverview = queryClient.getQueryState<TPlant[]>(['plants', 'overview']);

      const cacheState = plantsWithOverview ?? plantsWithoutOverview;

      if (!cacheState || Date.now() - cacheState.dataUpdatedAt > 5 * 60 * 1000) {
        return undefined;
      }

      if (!cacheState.data) {
        return undefined;
      }

      const plant = cacheState.data.find((p) => p.plantId === plantId);
      return plant;
    },
  });
};
